import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import { api } from "@/services/api.js"; 

export default new Vuex.Store({
  state: {
    planos: [],
    estados: [],
    tipos: [],
    especialidades: [],
    telefonesPrestadores: [],
    resultPrestador: null,
    resultProfisional: null,
    planoAtual:[],
    localSelecionado: [],
    planosSelecionados: [],
    scrollHandler: false,
    statusLoadingData: false,
    statusLoadingPlano: false,
    statusLoadingPlanosAtendidos: false,
    statusLoadingResultado: false,
    statusLoadingForm: false,
    statusLoadingRoute: false,
    statusLoadingEspecialidade: false,
    counterBuffer: 0
  },

  getters: {
    getPlanos(state){
      return state.planos;
    },
    
    getEstados(state){
      return state.estados;
    },

    getTipos(state){
      return state.tipos;
    },

    getEspecialidades(state){
      return state.tipos;
    },

    resultPrestador(state){
      return state.resultPrestador;
    },

    resultProfissional(state){
      return state.resultProfisional;
    },

    planoAtual(state){
      return state.planoAtual;
    },

    localSelecionado(state){
      return state.localSelecionado;
    },

    alturaElementoAtual(state){
      return state.alturaElemento;
    }
  },

  mutations: {
    addPlanos(state, payload){
      state.planos = payload;
    },

    addEstados(state, payload){
      state.estados = payload;
    },

    addTipos(state, payload){
      state.tipos = payload;
    },
    
    addEspecialidades(state, payload){
      state.especialidades = payload;
    },

    addPrestador(state, payload){
      state.resultPrestador = null;
      state.resultPrestador = payload;
    },

    addProfissional(state, payload){
      state.resultProfisional = null;
      state.resultProfisional = payload;
    },

    addPlanoAtual(state, payload){
      state.planoAtual = payload;
    },

    addLocalSelecionado (state, payload){
      state.localSelecionado = [];
      state.localSelecionado = payload;
    },

    addLoadingPlano(state, payload){
      state.statusLoadingPlano = payload;
    },

    addLoadingResultado(state, payload){
      state.statusLoadingResultado = payload;
    },

    addScrollHandler(state, payload){
      state.scrollHandler = payload;
    },

    addLoadingForm(state, payload){
      state.statusLoadingForm = payload;
    },

    addLoadingData(state, payload){
      state.statusLoadingData = payload;
    },

    addLoadingEspecialidade(state, payload){
      state.statusLoadingEspecialidade = payload;
    },

    addPlanosSelecionados (state, payload){
      state.planosSelecionados = [];
      state.planosSelecionados = payload;
    },

    addLoadingPlanosAtendidos(state, payload){
      state.statusLoadingPlanosAtendidos = payload;
    },

    addLoadingRoute(state, payload){
      state.statusLoadingRoute = payload;
    }
  },

  actions: {
    loadScrollHandler({ commit }, payload){
      commit("addScrollHandler", payload)
      
    },

    loadLoadingRoute({ commit }, payload){
      commit('addLoadingRoute', payload)
    },

    loadPlanos({ commit }){
      commit('addLoadingForm', true)
      api
      .get("planos")
      .then((response) => response.data)
      .then((planos) => {
        commit('addPlanos', planos)
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        commit('addLoadingForm', false),
        commit('addLoadingData', true)
      })
    },

    loadEstados({ commit }){
      api
      .get("estados")
      .then((response) => response.data)
      .then((estados) => {commit('addEstados', estados)})
  
      .catch((err) => {
        console.log(err);
      });
    },

    loadTipos({ commit }){
      api
      .get("tipos")
      .then((response) => response.data)
      .then((tipos) => {commit('addTipos', tipos)})
  
      .catch((err) => {
        console.log(err);
      });
    },

    loadPrestador({ commit }, payload){
      commit("addPrestador", payload);
    },

    loadProfissional({ commit }, payload){
      commit("addProfissional", payload);
    },


    

    loadPlanoAtual({ commit }, payload){
      commit("addPlanoAtual", []),

      commit("addPlanoAtual", payload)
    },

    loadLocalSelecionado({ commit }, payload){
      commit("addLocalSelecionado", payload)
    },

    loadEspecialidades({ commit }, payload){
      commit("addEspecialidades", payload)
    },

    loadPlanosSelecionados({ commit }, payload){
      commit("addPlanosSelecionados", payload)
    },

    loadLoadingForm({ commit }, payload){
      commit("addLoadingForm", payload)
    },

    loadLoadingPlanosAtendidos({ commit }, payload){
      commit("addLoadingPlanosAtendidos", payload)
    },

    loadLoadingEspecialidade({ commit }, payload){
      commit("addLoadingEspecialidade", payload)
      setTimeout(() => {
        commit("addLoadingEspecialidade", false)
      }, 200)
    }
  },
  modules: {
    
  }
})

